export default __webpack_public_path__ + "static/media/computer.df4b7117.jpg";